import request from '@/utils/request';

export function getCategory() {
  return request({
    url: '/category/value_text',
    method: 'get',
  })
}
export function getCategoryOption() {
  return request({
    url: '/category',
    method: 'get',
  })
}

export function queryOneCategory(parameter) {
  return request({
    url: '/category/' + parameter.name,
    method: 'get',
  })
}

export function queryOneCategoryOption(parameter) {
  return request({
    url: '/category/' + parameter.name + '/value_text',
    method: 'get',
  })
}

export function getDeptTree() {
  return request({
    url: "/dept/tree",
    method: 'get',
  })
}
